import { axios } from '@/utils/request'

// User recharge list
export function getChargeList(parameter = {}) {
  return axios({
    headers: {
      'prefix': 'invest'
    },
    url: '/invest-user/charge/list',
    method: 'post',
    data: parameter
  })
}

// Create recharge
export function createCharge(parameter = {}) {
  return axios({
    headers: {
      'prefix': 'invest'
    },
    url: '/invest-user/charge',
    method: 'post',
    data: parameter
  })
}

// Investor list-Investor info query
export function getInvestorList(parameter = {}) {
  return axios({
    headers: {
      'prefix': 'invest'
    },
    url: '/invest-user/list',
    method: 'post',
    data: parameter
  })
}

//Investor order list
export function getInvestmentOrderList(parameter = {}) {
  return axios({
    headers: {
      'prefix': 'invest'
    },
    url: '/invest-asset/invest-order-list',
    method: 'post',
    data: parameter
  })
}

//Investor details
export function getInvestorDetail(parameter = {}) {
  return axios({
    headers: {
      'prefix': 'invest'
    },
    url: '/invest-user/detail',
    method: 'post',
    data: parameter
  })
}
//Disable investor
export function disableInvestor(parameter = {}) {
  return axios({
    headers: {
      'prefix': 'invest'
    },
    url: '/invest-user/updateStatus',
    method: 'post',
    data: parameter
  })
}
// Investment status
export function getInvestStatusList(parameter = {}) {
  return axios({
    headers: {
      'prefix': 'invest'
    },
    url: '/invest-asset/invest-order-detail',
    method: 'post',
    data: parameter
  })
}
//Asset package target list
export function getAssetPackageList(parameter = {}) {
  return axios({
    headers: {
      'prefix': 'invest'
    },
    url: '/invest-asset/list',
    method: 'post',
    data: parameter
  })
}



// Borrower list
export function getBorrowerList(parameter = {}) {
  return axios({
    headers: {
      'prefix': 'invest'
    },
    url: '/invest-asset/loan-list',
    method: 'post',
    data: parameter
  })
}

// Investor list
export function getInvestorList1(parameter = {}) {
  return axios({
    headers: {
      'prefix': 'invest'
    },
    url: '/invest-asset/investor-list',
    method: 'post',
    data: parameter
  })
}
// Investor transaction overview
export function getInvestorTransactionOverview(parameter = {}) {
  return axios({
    headers: {
      'prefix': 'invest'
    },
    url: '/invest-flow/overview',
    method: 'post',
    data: parameter
  })
}

// Recharge records
export function getRechargeList(parameter = {}) {
  return axios({
    headers: {
      'prefix': 'invest'
    },
    url: '/invest-flow/recharge-list',
    method: 'post',
    data: parameter
  })
}

// Freeze records
export function getFreezeList(parameter = {}) {
  return axios({
    headers: {
      'prefix': 'invest'
    },
    url: '/invest-flow/freeze-list',
    method: 'post',
    data: parameter
  })
}

// Withdrawal records
export function getWithdrawalList(parameter = {}) {
  return axios({
    headers: {
      'prefix': 'invest'
    },
    url: '/invest-flow/withdraw-list',
    method: 'post',
    data: parameter
  })
}

// Match transaction records
export function getTransactionRecords(parameter = {}) {
  return axios({
    headers: {
      'prefix': 'invest'
    },
    url: '/invest-asset/list-match',
    method: 'post',
    data: parameter
  })
}

// Revenue distribution records
export function getIncomeDistributionList(parameter = {}) {
  return axios({
    headers: {
      'prefix': 'invest'
    },
    url: '/invest-asset/invest-repay-list',
    method: 'post',
    data: parameter
  })
}

// Export revenue distribution records
export function exportIncomeDistributionList(parameter = {}) {
  return axios({
    headers: {
      'prefix': 'invest'
    },
    url: '/invest-asset/invest-repay-list-export',
    method: 'post',
    data: parameter,
    responseType: 'blob'
  })
}

// Revenue distribution details
export function getIncomeDistributionDetail(parameter = {}) {
  return axios({
    headers: {
      'prefix': 'invest'
    },
    url: '/invest-asset/invest-repay-income-list',
    method: 'post',
    data: parameter
  })
}

//Borrower details
export function getAssetPackageBorrowerDetail(parameter = {}) {
  return axios({
    headers: {
      'prefix': 'invest'
    },
    url: '/invest-asset/loan-info',
    method: 'post',
    data: parameter
  })
}

// Fee details
export function getChargeDetail(parameter = {}) {
  return axios({
    headers: {
      'prefix': 'invest'
    },
    url: '/platform/amount/list',
    method: 'post',
    data: parameter
  })
}

// Fee list
export function getFeeConfig(parameter = {}) {
  return axios({
    headers: {
      'prefix': 'invest'
    },
    url: '/platform/config/list',
    method: 'post',
    data: parameter
  })
}

// Update fee config
export function updateFeeConfig(parameter = {}) {
  return axios({
    headers: {
      'prefix': 'invest'
    },
    url: '/platform/config/add_or_update',
    method: 'post',
    data: parameter
  })
}


export function updateSearch(parameter = {}) {
  return axios({
    headers: {
      'prefix': 'invest'
    },
    url: '/investorLog/log/search',
    method: 'post',
    data: parameter
  })
}

//New customer data conversion summary
export function getNewUserConversionFunnel(parameter = {}) {
  return axios({
    headers: {
      'prefix': 'invest'
    },
    url: '/newCustomer/conversion',
    method: 'post',
    data: parameter
  })
}

// New customer data conversion summary export
export function exportNewUserConversionFunnel(parameter = {}) {
  return axios({
    headers: {
      'prefix': 'invest'
    },
    url: '/newCustomer/conversionExcel',
    method: 'post',
    data: parameter,
    responseType: 'blob'
  })
}

//New customer conversion funnel
export function getNewfunnel(parameter = {}) {
  return axios({
    headers: {
      'prefix': 'invest'
    },
    url: '/newCustomer/funnel',
    method: 'post',
    data: parameter
  })
}

// New customer conversion funnel export
export function exportNewfunnel(parameter = {}) {
  return axios({
    headers: {
      'prefix': 'invest'
    },
    url: '/newCustomer/funnelExcel',
    method: 'post',
    data: parameter,
    responseType: 'blob'
  })
}

//Investor registration monitoring
export function getIloginMonitor(parameter = {}) {
  return axios({
    headers: {
      'prefix': 'invest'
    },
    url: '/newCustomer/registMonitor',
    method: 'post',
    data: parameter
  })
}

// Investor registration monitoring export
export function exportIloginMonitor(parameter = {}) {
  return axios({
    headers: {
      'prefix': 'invest'
    },
    url: '/newCustomer/registMonitorExcel',
    method: 'post',
    data: parameter,
    responseType: 'blob'
  })
}

// Investor login monitoring
export function getregistMonitor(parameter = {}) {
  return axios({
    headers: {
      'prefix': 'invest'
    },
    url: '/newCustomer/tologMonitor',
    method: 'post',
    data: parameter
  })
}

// Investor login monitoring export
export function exportRegistMonitor(parameter = {}) {
  return axios({
    headers: {
      'prefix': 'invest'
    },
    url: '/newCustomer/tologMonitorExcel',
    method: 'post',
    data: parameter,
    responseType: 'blob'
  })
}
// Asset package status
export function getAssetPackageStatus(parameter = {}) {
  return axios({
    headers: {
      'prefix': 'invest'
    },
    url: '/invest-asset/status',
    method: 'post',
    data: parameter
  })
}
// Order status
export function getOrderStatus(parameter = {}) {
  return axios({
    headers: {
      'prefix': 'invest'
    },
    url: '/invest-asset/invest-order-status',
    method: 'post',
    data: parameter
  })
}

// Revenue summary
export function getIncomeSummary(parameter = {}) {
  return axios({
    headers: {
      'prefix': 'invest'
    },
    url: '/platform/revenueDaily/getPage',
    method: 'post',
    data: parameter
  })
}

// Download loan contract
export function downloadLoanContract(parameter = {}) {
  return axios({
    headers: {
      'prefix': 'invest'
    },
    url: '/invest-asset/invest-order-contract-list',
    method: 'post',
    data: parameter,
    responseType: 'blob'
  })
}

// Product config list
export function getProductConfigList() {
  return axios({
    headers: {
      'prefix': 'web/webpublic'
    },
    url: '/vietnam/getProductFeeList',
    method: 'post',
  })
}


export function downloadContracts(parameter = {}) {
  return axios({
    headers: {
      'prefix': 'web/webpublic'
    },
    url: '/vietnam/exportContracts',
    method: 'get',
    params: parameter,
    responseType: 'blob'
  })
}

export function platformRevenueFlowList(parameter = {}) {
  return axios({
    headers: {
      'prefix': 'web/webpublic'
    },
    url: '/vietnam/platformRevenueFlowList',
    method: 'post',
    data: parameter,
  })
}



export function getaddOrUpdate(parameter = {}) {
  return axios({
    headers: {
      'prefix': 'invest'
    },
    url: '/customer-service-config/addOrUpdate',
    method: 'post',
    data: parameter
  })
}

export function getList(parameter = {}) {
  return axios({
    headers: {
      'prefix': 'invest'
    },
    url: '/customer-service-config/list',
    method: 'post',
    data: parameter
  })
}

export function deleteRecord(parameter = {}) {
  return axios({
    headers: {
      'prefix': 'invest'
    },
    url: `/delete/${parameter.id}`,
    method: 'post',
    data: parameter
  })
}


export function getVnAppValueInfo(parameter = {}) {
  return axios({
    headers: {
      'prefix': 'web/webpublic'
    },
    url: '/vietnam/getVnAppValueInfo',
    method: 'post',
    data: parameter,
  })
}

export function modifyVnAppValueInfo(parameter = {}) {
  return axios({
    headers: {
      'prefix': 'web/webpublic'
    },
    url: '/vietnam/modifyVnAppValueInfo',
    method: 'post',
    data: parameter,
  })
}





